import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { SERVICES } from "@/data/content";

export default function Services() {
  return (
    <section id="tjanster" data-testid="services-section" className="border-b border-white/10 py-20 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 flex flex-col gap-4 sm:mb-16 sm:flex-row sm:items-end sm:justify-between"
        >
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-neutral-500">02 / Tjänster</p>
            <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none tracking-tight text-white sm:text-5xl">
              Fjärrvärme, VVS &amp; svetsning
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-neutral-400">
            Vi byter fjärrvärmecentraler och utför arbeten för företag, byggföretag, fastighetsägare,
            bostadsrättsföreningar och privatpersoner i Storstockholm.
          </p>
        </motion.div>

        <div className="grid gap-px border border-white/10 bg-white/10 md:grid-cols-2">
          {SERVICES.map((service, i) => (
            <motion.article
              key={service.id}
              data-testid={`service-card-${service.id}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.12, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="steel-card group flex flex-col bg-coal p-7 transition-colors duration-300 sm:p-9"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-display text-5xl font-bold text-white/10 transition-colors duration-300 group-hover:text-white/20">
                  {service.num}
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
                  {service.tag}
                </span>
              </div>
              <h3 className="mt-8 font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl">
                {service.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400">{service.description}</p>
              <ul className="mt-7 space-y-2.5 border-t border-white/10 pt-6">
                {service.bullets.map((b) => (
                  <li key={b} className="flex items-center gap-2.5 text-sm text-neutral-300">
                    <Plus className="h-3.5 w-3.5 shrink-0 text-weld" strokeWidth={3} />
                    {b}
                  </li>
                ))}
              </ul>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
